(function ($, Drupal, drupalSettings) {
  'use strict';

  Drupal.behaviors.BDLakePage = {
    attach: function (context, settings) {
      var bdhero = $('.page-node-type-bill-dance-lake-page .field--name-field-lake-images');
      var me = Drupal.blazy;

      if (bdhero.length) {
        bdhero.each(function () {
          if ($(this).find('.field__item').length > 1) {
            $(this).slick({
              dots: true,
              arrows: false,
              infinite: false,
              mobileFirst: true,
              slidesToShow: 1,
              useCss: false,
              variableWidth: true
            });

            $(this).on('afterChange', function (event, slick, currentSlide, nextSlide) {
              var asset = location.href;
              dataLayer.push({
                eventCategory: 'slider',
                eventAction: 'click',
                eventLabel: asset,
                eventvalue: '',
                event: 'eventClick'
              }); // eslint-disable-line no-undef
              me.init.revalidate();
            });
          }
        });
      }
    }
  };
})(jQuery, Drupal, drupalSettings);
